module.exports = __webpack_public_path__ + "static/media/LighterGrayCheck.bcc6d55e.png";